import type { NdtAssetAllocation, NdtAssetAllocationRepository } from "../../../domain/ndt/ndt-asset-allocation.js";

/** Usado no modo local sem banco. O catálogo de ativos continua independente de Cliente. */
export class InMemoryNdtAssetAllocationRepository implements NdtAssetAllocationRepository {
  private allocations = new Map<string,NdtAssetAllocation>();
  async listByAsset(id:string):Promise<NdtAssetAllocation[]> {
    return [...this.allocations.values()].filter(a=>a.assetId===id)
      .sort((a,b)=>b.assignedAt.localeCompare(a.assignedAt));
  }
  async activeForAsset(id:string):Promise<NdtAssetAllocation|null>{
    return [...this.allocations.values()].find(a=>a.assetId===id&&!a.returnedAt) ?? null;
  }
  async create(item:NdtAssetAllocation):Promise<void>{
    if(await this.activeForAsset(item.assetId)) throw new Error("Instrumento já alocado.");
    this.allocations.set(item.id,{...item});
  }
  async close(id:string,clientId:string,userId:string,returnedAt:string):Promise<boolean>{
    const item=this.allocations.get(id);
    if(!item || item.clientId!==clientId || item.returnedAt)return false;
    this.allocations.set(id,{...item,returnedAt,returnedByUserId:userId});
    return true;
  }
}
